import {Api} from './Api';
import Conta from "../_lib/models/Conta";
import {UserInfo} from "../_lib/models/UserInfo";

export enum DataAcessMode {
    BASIC,
    CONTACT,
    FULL
}

export default new class ApiConta extends Api {
    info(mode: DataAcessMode = DataAcessMode.BASIC) {
        return this._get<UserInfo>(this.routes.api('/conta/info'),{mode});
    }

    cadastrar(usuario: Conta) {
        return this._post(this.routes.api('/conta/cadastrar'), usuario);
    }
}
